import Vue from 'vue';
import Router from 'vue-router';
import Meta from 'vue-meta';
import HomePage from '@/components/HomePage';
import ErrorPage from '@/components/ErrorPage';
import PlaylistVideo from '@/components/PlaylistVideo';
import store from '../store/index';

Vue.use(Router);
Vue.use(Meta);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/canal/:videoId(\\d+)/:title',
      name: 'canalVideo',
      component: HomePage,
    },
    {
      path: '/:videoId(\\d+)/:title',
      name: 'video',
      component: HomePage,
    },
    {
      path: '/theme/:themeId(\\d+)',
      name: 'theme',
      component: HomePage,
    },
    {
      path: '/playlist/:playlistId',
      name: 'playlist',
      component: PlaylistVideo,
    },
    {
      path: '/:category(all|trends|popular|home)',
      name: 'home',
      component: HomePage,
      props: route => ({
        query: route.query.q,
      }),
    },
    {
      path: '/site/:category(all|trends|popular|home)/:idChannal',
      name: 'embedSite',
      component: HomePage,
      props: route => ({
        query: route.query.q,
      }),
       beforeEnter(to, from, next) {
        if (to.name==='embedSite')
        {
           store.commit('setIsSiteEmbed',true);
        }
        next();
      },
    },
    {
      path: '/',
      name: 'index',
      redirect: process.env.NOT_HOME_CONF ? '/home' : 'trends',
    },
    /*{
      path: '*',
      redirect: '/404',
    },*/
    {
      path: '/404',
      name: 'error',
      component: ErrorPage,
    },

  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js